import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Google Web App URL used by the waitlist form.
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwaFCqQV0PG8_LAx3v7exnidBDrqcEVugCQRx5v6eaLwRgA8g_ElfV7hxoFUp1kh-TN/exec";

export default function Unsubscribe() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Pre-fill email if passed in query string (e.g. /unsubscribe?email=user@test.com)
  useEffect(() => {
    const queryEmail = searchParams.get("email");
    if (queryEmail) {
      setEmail(queryEmail);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      // Keep the waitlist sheet columns intact, while marking this row as an
      // unsubscribe. The email is the only value from the visitor.
      const formData = new FormData();
      formData.append("timestamp", "unsubscribe");
      formData.append("name", "unsubscribe");
      formData.append("email", email.trim());
      formData.append("age", "unsubscribe");
      formData.append("location", "unsubscribe");
      formData.append("activities", "unsubscribe");
      formData.append("other", "unsubscribe");
      formData.append("referrer_source", "unsubscribe");
      formData.append("referrer_medium", "unsubscribe");

      const response = await fetch(SCRIPT_URL, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        throw new Error("Failed to unsubscribe. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrorMsg("Something went wrong. Please try again or contact support.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--c3-light, #f5f5f5)" }}>
      {/* Header */}
      <div
        style={{
          padding: "4rem 1rem",
          background: "color-mix(in srgb, var(--c1) 45%, white 55%)",
          textAlign: "center",
          color: "var(--ink)",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", fontWeight: 900, margin: 0 }}>
          Unsubscribe from BeFitFriends Emails
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            color: "var(--ink-muted)",
            marginTop: "0.5rem",
          }}
        >
          Please confirm your email address below to unsubscribe from our waitlist updates.
        </p>
      </div>

      {/* Form Container */}
      <div className="container" style={{ maxWidth: "600px", margin: "3rem auto", padding: "0 1rem" }}>
        {!submitted ? (
          <form onSubmit={handleSubmit} style={{ display: "grid", gap: "1.5rem" }}>
            <div>
              <label
                htmlFor="email"
                style={{
                  display: "block",
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  color: "var(--ink)",
                }}
              >
                Your Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                style={{
                  width: "100%",
                  padding: "0.75rem 1rem",
                  fontSize: "1rem",
                  border: "1px solid var(--hairline, #ccc)",
                  borderRadius: "8px",
                  fontFamily: "inherit",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading || !email}
              style={{
                padding: "0.75rem 2rem",
                fontSize: "1rem",
                fontWeight: 600,
                background: loading ? "#9ca3af" : "#6baccc",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? "Removing..." : "Confirm Unsubscribe"}
            </button>

            {errorMsg && (
              <p style={{ color: "#dc2626", margin: 0, textAlign: "center", fontSize: "0.9rem" }}>
                {errorMsg}
              </p>
            )}
          </form>
        ) : (
          /* Proper Success Confirmation */
          <div
            style={{
              padding: "1.5rem",
              background: "#e8f5e9",
              border: "1px solid #4caf50",
              borderRadius: "8px",
              color: "#2e7d32",
              textAlign: "center",
            }}
          >
            <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.2rem" }}>✓ You have been unsubscribed</h3>
            <p style={{ margin: 0, fontSize: "0.95rem" }}>
              <strong>{email}</strong> has been removed from future waitlist updates.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
